<template>
<ItpBox
  alignItems="center"
  class="items-spacing w-100"
  v-if="loaded"
>
  <ItpBox
    direction="column"
  >
    <ItpText
      muted
      class="mb-0"
    >
      {{ resourceTitle }}
    </ItpText>
    <ItpText
      tag="h4"
      :text="resourceKey"
      class="mb-0"
    >
    </ItpText>
  </ItpBox>
  <UcInvoiceTypeBadge
    :value="invoice.invoice_type"
    :kind="invoice.invoice_kind"
    :advance="invoice.is_advance"
  >
  </UcInvoiceTypeBadge>
  <UcInvoiceStatusBadge
    :value="invoice.status"
  >
  </UcInvoiceStatusBadge>
  <UcInvoiceNumberingSelector
    :invoice="invoice"
    :value="invoice.meta.numbering"
    :options="invoice.meta.numbering_options"
    v-if="invoice.meta && invoice.meta.numbering"
    @reload="evh_1048678296148443_reload($event, {})"
  >
  </UcInvoiceNumberingSelector>
  <DIV
    v-if="invoice.tags && invoice.tags.length"
  >
    <span
      class="badge badge-secondary mx-1 shadow-none"
      v-for="tag in invoice.tags"
    >
      {{ tag }}
    </span>
  </DIV>
  <DIV
    :title="'Closed'|gettext"
    v-if="invoice.isReadOnly"
  >
    <ItpIcon
      :icon="$config.lockIcon"
    >
    </ItpIcon>
  </DIV>
  <DIV
    class="text-green-500"
    v-if="invoice.authority_transaction_id"
  >
    <DIV
      :title="invoice.authority_transaction_id"
    >
      <ItpIcon
        icon="fluent:cloud-sync-complete-16-regular"
      >
      </ItpIcon>
    </DIV>
    <DIV
      :title="JSON.stringify(invoice.authority_transaction_status)"
    >
      <ItpIcon
        icon="fa-question-circle"
      >
      </ItpIcon>
    </DIV>
  </DIV>
  <ItpBox
    direction="column"
    v-if="invoice.reference_invoice"
  >
    <ItpText
      muted
      class="mb-0"
    >
      {{ 'Reference invoice'|pgettext('Invoice') }}
    </ItpText>
    <UcInvoiceMiniCard
      :item="invoice.reference_invoice"
      no-icon
    >
    </UcInvoiceMiniCard>
  </ItpBox>
  <ItpBox
    direction="column"
    v-if="invoice.referencing_invoices && invoice.referencing_invoices.length"
  >
    <ItpText
      muted
      class="mb-0"
    >
      {{ 'Referencing invoices'|pgettext('Invoice') }}
    </ItpText>
    <ItpBox>
      <UcInvoiceMiniCard
        :key="obj.id"
        :item="obj"
        no-icon
        class="mr-2"
        v-for="obj in invoice.referencing_invoices"
      >
      </UcInvoiceMiniCard>
    </ItpBox>
  </ItpBox>
  <Icon
    :icon="'flagpack:' + invoice.language"
    :title="'Invoice Language'|pgettext('Invoice')"
    v-if="!invoice.isNew"
  >
  </Icon>
  <DIV
    class="btn-toolbar ml-auto flex-nowrap"
  >
    <BtnIssueInvoice
      :invoice="invoice"
      class="ml-auto mr-2"
      v-if="invoice.meta && invoice.meta.issuance_status.status == 'not_started'"
      @success="evh_6639903447389385_success($event, {})"
    >
    </BtnIssueInvoice>
    <BtnSyncInvoice
      :invoice="invoice"
      class="ml-auto mr-2"
      v-if="invoice.meta && invoice.meta.billing_service_status.status == 'not_started'"
      @success="evh_3803044933457651_success($event, {})"
    >
    </BtnSyncInvoice>
    <BtnReportInvoiceData
      :resource="invoice"
      class="ml-auto mr-2"
      v-if="invoice.meta && (invoice.meta.data_reporting_status.status == 'not_started' || invoice.meta.data_reporting_status.status == 'error')"
      @success="evh_4764767232201234_success($event, {})"
    >
    </BtnReportInvoiceData>
    <BtnSyncResource
      :resource="invoice"
      target="irent"
      confirmMessage="A számlát csak egyszer lehet felölteni a régi rendszerbe,
feltöltés után a számlát már nem lehet módosítani."
      class="ml-auto mr-2"
      v-if="invoice.meta && invoice.meta.sync_to_external_system_status.status == 'not_started'"
      @success="evh_7992484462910578_success($event, {})"
    >
    </BtnSyncResource>
    <ItpButton
      :icon="$config.editIcon"
      :tooltip="'Edit'|gettext"
      variant="light"
      class="ml-auto mr-2"
      v-if="!invoice.isNew && !invoice.isReadOnly"
      @click.prevent.stop="evh_7716964648426498_clickPreventStop($event, {})"
    >
    </ItpButton>
    <ItpButton
      icon="fa-sync-alt"
      :tooltip="'Reload'|gettext"
      :spinning="actions.reload.isRunning"
      variant="light"
      class="ml-auto mr-2"
      v-if="!invoice.isNew"
      @click.prevent.stop="evh_2940653511262489_clickPreventStop($event, {})"
    >
    </ItpButton>
    <UcInvoiceViewDocumentDropdown
      :invoice="invoice"
      class="ml-auto mr-2"
      @click.prevent.stop="evh_689536327456849_clickPreventStop($event, {})"
    >
    </UcInvoiceViewDocumentDropdown>
    <ItpButton
      variant="light"
      icon="icon-park-outline:preview-open"
      :href="invoice.preview_url"
      :tooltip="'Open preview'|pgettext('Invoice')"
      target="_blank"
      use-auth
      show-spinner
      class="ml-auto mr-2"
      v-if="invoice.preview_url"
    >
    </ItpButton>
    <ItpButton
      variant="light"
      icon="icon-park-outline:log"
      :tooltip="'Show log messages'|pgettext('Invoice')"
      class="ml-auto mr-2"
      v-if="invoice.log_messages"
      @click.prevent.stop="evh_8254501898831426_clickPreventStop($event, {})"
    >
    </ItpButton>
    <b-dropdown
      right
      variant="light"
      no-caret
      class="border"
      v-if="!invoice.isNew"
    >
      <ItpIcon
        fa="bars"
        class="mx-1"
        slot="button-content"
      >
      </ItpIcon>
      <ItpButton
        dropdown-item
        :text="'Register invoice'|pgettext('Invoice')"
        :tooltip="'Add this invoice to the invoice register'|pgettext('Invoice')"
        variant="default"
        v-if="invoiceIsRegistrable"
        @click="evh_951936257455896_click($event, {})"
      >
      </ItpButton>
      <ItpButton
        dropdown-item
        :text="'Copy'|pgettext('BtnCopyResource')"
        :tooltip="'Create new invoice from this one'|pgettext('Invoice')"
        variant="default"
        @click="evh_7010716094810887_click($event, {})"
      >
      </ItpButton>
      <ItpButton
        dropdown-item
        :text="'Create pass-through'|pgettext('Invoice')"
        :tooltip="messages.createPassThroughTooltip"
        variant="default"
        :disabled="!invoicePassThroughIsEnabled"
        v-if="!invoice.isNew"
        @click="evh_4971252216919813_click($event, {})"
      >
      </ItpButton>
      <ItpButton
        dropdown-item
        :text="'Create advance'|pgettext('Invoice')"
        :tooltip="messages.createAdvanceInvoiceTooltip"
        variant="default"
        :disabled="!canCreateAdvanceInvoice"
        v-if="!invoice.isNew"
        @click="evh_3581444176199717_click($event, {})"
      >
      </ItpButton>
      <ItpButton
        dropdown-item
        :text="'Create final'|pgettext('Invoice')"
        :tooltip="messages.createFinalInvoiceTooltip"
        variant="default"
        :disabled="!canCreateFinalInvoice"
        v-if="!invoice.isNew"
        @click="evh_6391442819935878_click($event, {})"
      >
      </ItpButton>
      <hr>
      </hr>
      <ItpButton
        dropdown-item
        :text="'Create storno'|pgettext('Invoice')"
        :tooltip="createStornoTooltip"
        variant="default"
        :disabled="!invoiceIsReversible"
        v-if="!invoice.isNew"
        @click="evh_2988515090283815_click($event, {})"
      >
      </ItpButton>
      <ItpButton
        dropdown-item
        variant="default"
        :text="'Create corrector'|pgettext('Invoice')"
        :tooltip="createCorrectorTooltip"
        :disabled="!invoiceIsModifiable"
        v-if="!invoice.isNew"
        @click="evh_3478991899028773_click($event, {})"
      >
      </ItpButton>
      <BtnLockResource
        no-icon
        dropdown-item
        :resource="invoice"
        :tooltip="'Lock invoice'|pgettext('Invoice')"
        v-if="!invoice.isNew && !invoice.isReadOnly"
        @success="evh_8376575288437415_success($event, {})"
      >
      </BtnLockResource>
      <BtnDeleteResource
        no-icon
        dropdown-item
        :resource="invoice"
        :tooltip="'Delete invoice'|pgettext('Invoice')"
        v-if="!invoice.isNew && !invoice.isReadOnly"
        @success="evh_3958027742391354_success($event, {})"
      >
      </BtnDeleteResource>
      <hr>
      </hr>
      <ItpButton
        dropdown-item
        :text="'History'|pgettext('BtnResourceHistory')"
        :tooltip="'Invoice history'|pgettext('Invoice')"
        variant="default"
        @click.prevent.stop="evh_8122162285230843_clickPreventStop($event, {})"
      >
      </ItpButton>
    </b-dropdown>
  </DIV>
</ItpBox>
</template>

<script lang="ts">

import * as _ from 'lodash';
import Big from 'big.js';
import { Vue, Component, Watch, Prop } from 'vue-property-decorator';
import { mixins } from 'vue-class-component';
import {
  addRoute, UserComponentMixin, ComponentValueCache, actions
} from '@integro/core';

@Component()
export default class UcInvoiceHeader extends mixins(UserComponentMixin) {
  componentMetadata = {
    kind: "usercontrol",
  };

  beforeCreate() {
  }

  @Prop({
    required: true,
    type: Object,
  })
  invoice!: object;

  @Watch('invoice')
  onInvoice(newValue: any, oldValue: any) {
    if (_.isEqual(newValue, oldValue)) return;
    this.loadDataThrottled("invoice")
  }

  @Prop({
    type: String,
    default: function() {
      return this.$fn.randomElementId()
    },
  })
  formId!: string;

  @Watch('formId')
  onForm_id(newValue: any, oldValue: any) {
    if (_.isEqual(newValue, oldValue)) return;
    this.loadDataThrottled("formId")
  }

  @Prop({
    type: String,
  })
  invoiceNumber!: string;

  @Watch('invoiceNumber')
  onInvoice_number(newValue: any, oldValue: any) {
    if (_.isEqual(newValue, oldValue)) return;
    this.loadDataThrottled("invoiceNumber")
  }

  @Prop({
    required: true,
    type: Object,
  })
  formContext!: object;

  @Watch('formContext')
  onForm_context(newValue: any, oldValue: any) {
    if (_.isEqual(newValue, oldValue)) return;
    this.loadDataThrottled("formContext")
  }

  messages!: any;
  ux!: any;
  dataMembers = ['messages', 'ux'];

  data() {
    return {
      ...this.mixinData(),
      actions: this.getActions(),
      ...{
        messages: {
          newTransaction: this.$fn.pgettext("Invoice", "New Invoice"),
          invoiceKind: {
            incoming: this.$fn.pgettext("InvoiceKind", "Incoming Invoice"),
            outgoing: this.$fn.pgettext("InvoiceKind", "Outgoing Invoice"),
          }
          ,
          createCorrectorTooltip: this.$fn.pgettext("Invoice", "Create corrector invoice"),
          createStornoTooltip: this.$fn.pgettext("Invoice", "Create storno invoice"),
          createPassThroughTooltip: this.$fn.pgettext("Invoice|Tooltip", "Rebilling the line items to a designated client."),
          createAdvanceInvoiceTooltip: this.$fn.pgettext("Invoice|Tooltip", "Create advance invoice from a Pro Forma invoice."),
          createFinalInvoiceTooltip: this.$fn.pgettext("Invoice|Tooltip", "Create final invoice from a Pro Forma or advance invoice."),
        }
        ,
        ux: null,
      },
    }
  }

  get resourceTitle() {
    if (this.loaded) {

      return this.messages.invoiceKind[this.invoice.invoice_kind]
    }
    return null;
  }

  get resourceKey() {
    if (this.loaded) {

      return this.invoiceNumber || (this.invoice.isNew ? this.messages.newTransaction : this.invoice.invoice_number)
    }
    return null;
  }

  get createCorrectorTooltip() {
    if (this.loaded) {

      return _.get(this.invoice, 'meta.modifiable.message') || this.messages.createCorrectorTooltip
    }
    return null;
  }

  get createStornoTooltip() {
    if (this.loaded) {

      return _.get(this.invoice, 'meta.reversible.message') || this.messages.createStornoTooltip
    }
    return null;
  }

  get invoiceIsReversible() {
    if (this.loaded) {

      return _.get(this.invoice, 'meta.reversible.result')
    }
    return null;
  }

  get invoiceIsModifiable() {
    if (this.loaded) {

      return _.get(this.invoice, 'meta.modifiable.result')
    }
    return null;
  }

  get invoiceIsRegistrable() {
    if (this.loaded) {

      return _.get(this.invoice, 'meta.registrable.result')
    }
    return null;
  }

  get invoicePassThroughIsEnabled() {
    if (this.loaded) {

      return _.get(this.invoice, 'meta.pass_through_enabled') === true ||
        _.get(this.invoice, 'meta.pass_through_enabled.result')
    }
    return null;
  }

  get canCreateAdvanceInvoice() {
    if (this.loaded) {

      return _.get(this.invoice, 'meta.can_create_advance_invoice') === true
    }
    return null;
  }

  get canCreateFinalInvoice() {
    if (this.loaded) {

      return _.get(this.invoice, 'meta.can_create_final_invoice') === true
    }
    return null;
  }

  async act_1048678296148443_emit_7134_getActionArgs($event: actions.ActionEvent): Promise<actions.EmitActionArgs> {
    // parameterResolver name=act_1048678296148443_emit_7134, alias=undefined
    return {
      event: "reload",
    }
  }

  async evh_1048678296148443_reload(event: Event, scope: Dictionary<any>) {
    return await this.actions.evh_1048678296148443_reload.executeFromDOM(this, event, scope);
  }

  async act_6639903447389385_emit_7136_getActionArgs($event: actions.ActionEvent): Promise<actions.EmitActionArgs> {
    // parameterResolver name=act_6639903447389385_emit_7136, alias=undefined
    return {
      event: "reload",
    }
  }

  async evh_6639903447389385_success(event: Event, scope: Dictionary<any>) {
    return await this.actions.evh_6639903447389385_success.executeFromDOM(this, event, scope);
  }

  async act_3803044933457651_emit_7138_getActionArgs($event: actions.ActionEvent): Promise<actions.EmitActionArgs> {
    // parameterResolver name=act_3803044933457651_emit_7138, alias=undefined
    return {
      event: "reload",
    }
  }

  async evh_3803044933457651_success(event: Event, scope: Dictionary<any>) {
    return await this.actions.evh_3803044933457651_success.executeFromDOM(this, event, scope);
  }

  async act_4764767232201234_emit_7140_getActionArgs($event: actions.ActionEvent): Promise<actions.EmitActionArgs> {
    // parameterResolver name=act_4764767232201234_emit_7140, alias=undefined
    return {
      event: "reload",
    }
  }

  async evh_4764767232201234_success(event: Event, scope: Dictionary<any>) {
    return await this.actions.evh_4764767232201234_success.executeFromDOM(this, event, scope);
  }

  async act_7992484462910578_emit_7142_getActionArgs($event: actions.ActionEvent): Promise<actions.EmitActionArgs> {
    // parameterResolver name=act_7992484462910578_emit_7142, alias=undefined
    return {
      event: "reload",
    }
  }

  async evh_7992484462910578_success(event: Event, scope: Dictionary<any>) {
    return await this.actions.evh_7992484462910578_success.executeFromDOM(this, event, scope);
  }

  async act_7716964648426498_emit_7146_getActionArgs($event: actions.ActionEvent): Promise<actions.EmitActionArgs> {
    // parameterResolver name=act_7716964648426498_emit_7146, alias=undefined
    return {
      event: "reload",
    }
  }

  async evh_7716964648426498_close_7145_getWhen($event: actions.ActionEvent): Promise<actions.EventHandlerImplArgs> {
    // parameterResolver name=evh_7716964648426498_close_7145, alias=undefined
    return $event.data.modalResult.ok
  }

  async act_7716964648426498_showModal_7144_getActionArgs($event: actions.ActionEvent): Promise<actions.ShowModalActionArgs> {
    // parameterResolver name=act_7716964648426498_showModal_7144, alias=undefined
    return {
      name: "InvoiceEditor",
      props: {
        invoice: _.cloneDeep(this.invoice),
      }
      ,
    }
  }

  async evh_7716964648426498_clickPreventStop(event: Event, scope: Dictionary<any>) {
    return await this.actions.evh_7716964648426498_clickPreventStop.executeFromDOM(this, event, scope);
  }

  async act_2940653511262489_emit_7148_getActionArgs($event: actions.ActionEvent): Promise<actions.EmitActionArgs> {
    // parameterResolver name=act_2940653511262489_emit_7148, alias=reload
    return {
      event: "reload",
    }
  }

  async evh_2940653511262489_clickPreventStop(event: Event, scope: Dictionary<any>) {
    return await this.actions.evh_2940653511262489_clickPreventStop.executeFromDOM(this, event, scope);
  }

  async act_689536327456849_emit_7150_getActionArgs($event: actions.ActionEvent): Promise<actions.EmitActionArgs> {
    // parameterResolver name=act_689536327456849_emit_7150, alias=reload
    return {
      event: "reload",
    }
  }

  async evh_689536327456849_clickPreventStop(event: Event, scope: Dictionary<any>) {
    return await this.actions.evh_689536327456849_clickPreventStop.executeFromDOM(this, event, scope);
  }

  async act_8254501898831426_showModal_7152_getActionArgs($event: actions.ActionEvent): Promise<actions.ShowModalActionArgs> {
    // parameterResolver name=act_8254501898831426_showModal_7152, alias=undefined
    return {
      name: "InvoiceLogMessageViewer",
      props: {
        invoiceId: this.invoice.id,
      }
      ,
    }
  }

  async evh_8254501898831426_clickPreventStop(event: Event, scope: Dictionary<any>) {
    return await this.actions.evh_8254501898831426_clickPreventStop.executeFromDOM(this, event, scope);
  }

  async act_951936257455896_emit_7156_getActionArgs($event: actions.ActionEvent): Promise<actions.EmitActionArgs> {
    // parameterResolver name=act_951936257455896_emit_7156, alias=undefined
    return {
      event: "reload",
    }
  }

  async evh_951936257455896_close_7155_getWhen($event: actions.ActionEvent): Promise<actions.EventHandlerImplArgs> {
    // parameterResolver name=evh_951936257455896_close_7155, alias=undefined
    return $event.data.modalResult.ok
  }

  async act_951936257455896_showModal_7154_getActionArgs($event: actions.ActionEvent): Promise<actions.ShowModalActionArgs> {
    // parameterResolver name=act_951936257455896_showModal_7154, alias=registerInvoice
    return {
      name: "RegisterEntry",
      props: {
        invoice: this.invoice,
      }
      ,
    }
  }

  async evh_951936257455896_click(event: Event, scope: Dictionary<any>) {
    return await this.actions.evh_951936257455896_click.executeFromDOM(this, event, scope);
  }

  async act_7010716094810887_emit_7160_getActionArgs($event: actions.ActionEvent): Promise<actions.EmitActionArgs> {
    // parameterResolver name=act_7010716094810887_emit_7160, alias=undefined
    return {
      event: "created",
      value: $event.data.response.data,
    }
  }

  async act_7010716094810887_request_7158_getActionArgs($event: actions.ActionEvent): Promise<actions.RequestActionArgs> {
    // parameterResolver name=act_7010716094810887_request_7158, alias=createInvoicecopy
    return {
      operation: "create_invoice",
      data: { invoice_id: this.invoice.id, invoice_type: 'copy' },
    }
  }

  async evh_7010716094810887_click(event: Event, scope: Dictionary<any>) {
    return await this.actions.evh_7010716094810887_click.executeFromDOM(this, event, scope);
  }

  async act_4971252216919813_emit_7164_getActionArgs($event: actions.ActionEvent): Promise<actions.EmitActionArgs> {
    // parameterResolver name=act_4971252216919813_emit_7164, alias=undefined
    return {
      event: "reload",
    }
  }

  async evh_4971252216919813_close_7163_getWhen($event: actions.ActionEvent): Promise<actions.EventHandlerImplArgs> {
    // parameterResolver name=evh_4971252216919813_close_7163, alias=undefined
    return $event.data.modalResult.ok
  }

  async act_4971252216919813_showModal_7162_getActionArgs($event: actions.ActionEvent): Promise<actions.ShowModalActionArgs> {
    // parameterResolver name=act_4971252216919813_showModal_7162, alias=createPassThroughInvoice
    return {
      name: "CreatePassThroughInvoice",
      props: {
        invoice: this.invoice,
      }
      ,
    }
  }

  async evh_4971252216919813_click(event: Event, scope: Dictionary<any>) {
    return await this.actions.evh_4971252216919813_click.executeFromDOM(this, event, scope);
  }

  async act_3581444176199717_emit_7168_getActionArgs($event: actions.ActionEvent): Promise<actions.EmitActionArgs> {
    // parameterResolver name=act_3581444176199717_emit_7168, alias=undefined
    return {
      event: "created",
      value: $event.data.response.data,
    }
  }

  async act_3581444176199717_request_7166_getActionArgs($event: actions.ActionEvent): Promise<actions.RequestActionArgs> {
    // parameterResolver name=act_3581444176199717_request_7166, alias=createAdvanceInvoice
    return {
      operation: "create_invoice",
      data: { invoice_id: this.invoice.id, invoice_type: 'advance' },
    }
  }

  async evh_3581444176199717_click(event: Event, scope: Dictionary<any>) {
    return await this.actions.evh_3581444176199717_click.executeFromDOM(this, event, scope);
  }

  async act_6391442819935878_emit_7172_getActionArgs($event: actions.ActionEvent): Promise<actions.EmitActionArgs> {
    // parameterResolver name=act_6391442819935878_emit_7172, alias=undefined
    return {
      event: "created",
      value: $event.data.response.data,
    }
  }

  async act_6391442819935878_request_7170_getActionArgs($event: actions.ActionEvent): Promise<actions.RequestActionArgs> {
    // parameterResolver name=act_6391442819935878_request_7170, alias=createFinalInvoice
    return {
      operation: "create_invoice",
      data: { invoice_id: this.invoice.id, invoice_type: 'final' },
    }
  }

  async evh_6391442819935878_click(event: Event, scope: Dictionary<any>) {
    return await this.actions.evh_6391442819935878_click.executeFromDOM(this, event, scope);
  }

  async act_2988515090283815_emit_7176_getActionArgs($event: actions.ActionEvent): Promise<actions.EmitActionArgs> {
    // parameterResolver name=act_2988515090283815_emit_7176, alias=undefined
    return {
      event: "created",
      value: $event.data.response.data,
    }
  }

  async act_2988515090283815_request_7174_getActionArgs($event: actions.ActionEvent): Promise<actions.RequestActionArgs> {
    // parameterResolver name=act_2988515090283815_request_7174, alias=createStornoInvoice
    return {
      operation: "create_invoice",
      data: { invoice_id: this.invoice.id, invoice_type: 'storno' },
    }
  }

  async evh_2988515090283815_click(event: Event, scope: Dictionary<any>) {
    return await this.actions.evh_2988515090283815_click.executeFromDOM(this, event, scope);
  }

  async act_3478991899028773_emit_7180_getActionArgs($event: actions.ActionEvent): Promise<actions.EmitActionArgs> {
    // parameterResolver name=act_3478991899028773_emit_7180, alias=undefined
    return {
      event: "created",
      value: $event.data.response.data,
    }
  }

  async act_3478991899028773_request_7178_getActionArgs($event: actions.ActionEvent): Promise<actions.RequestActionArgs> {
    // parameterResolver name=act_3478991899028773_request_7178, alias=createCorrectorIvoice
    return {
      operation: "create_invoice",
      data: {
        invoice_id: this.invoice.id,
        invoice_type: 'correction',
        invoice_lines: _.map(this.formContext.selectedInvoiceLines, p => p.id).join(',')
      },
    }
  }

  async evh_3478991899028773_click(event: Event, scope: Dictionary<any>) {
    return await this.actions.evh_3478991899028773_click.executeFromDOM(this, event, scope);
  }

  async act_8376575288437415_emit_7182_getActionArgs($event: actions.ActionEvent): Promise<actions.EmitActionArgs> {
    // parameterResolver name=act_8376575288437415_emit_7182, alias=undefined
    return {
      event: "reload",
    }
  }

  async evh_8376575288437415_success(event: Event, scope: Dictionary<any>) {
    return await this.actions.evh_8376575288437415_success.executeFromDOM(this, event, scope);
  }

  async act_3958027742391354_emit_7184_getActionArgs($event: actions.ActionEvent): Promise<actions.EmitActionArgs> {
    // parameterResolver name=act_3958027742391354_emit_7184, alias=undefined
    return {
      event: "deleted",
    }
  }

  async evh_3958027742391354_success(event: Event, scope: Dictionary<any>) {
    return await this.actions.evh_3958027742391354_success.executeFromDOM(this, event, scope);
  }

  async act_8122162285230843_showModal_7186_getActionArgs($event: actions.ActionEvent): Promise<actions.ShowModalActionArgs> {
    // parameterResolver name=act_8122162285230843_showModal_7186, alias=undefined
    return {
      name: "entityEvents",
      props: {
        entityId: this.invoice.id,
      }
      ,
    }
  }

  async evh_8122162285230843_clickPreventStop(event: Event, scope: Dictionary<any>) {
    return await this.actions.evh_8122162285230843_clickPreventStop.executeFromDOM(this, event, scope);
  }

  actions!: {
    act_1048678296148443_emit_7134: actions.EmitAction;
    evh_1048678296148443_reload_7133: actions.EventHandlerImpl;
    evh_1048678296148443_reload: actions.EventHandlerGroup;
    act_6639903447389385_emit_7136: actions.EmitAction;
    evh_6639903447389385_success_7135: actions.EventHandlerImpl;
    evh_6639903447389385_success: actions.EventHandlerGroup;
    act_3803044933457651_emit_7138: actions.EmitAction;
    evh_3803044933457651_success_7137: actions.EventHandlerImpl;
    evh_3803044933457651_success: actions.EventHandlerGroup;
    act_4764767232201234_emit_7140: actions.EmitAction;
    evh_4764767232201234_success_7139: actions.EventHandlerImpl;
    evh_4764767232201234_success: actions.EventHandlerGroup;
    act_7992484462910578_emit_7142: actions.EmitAction;
    evh_7992484462910578_success_7141: actions.EventHandlerImpl;
    evh_7992484462910578_success: actions.EventHandlerGroup;
    act_7716964648426498_emit_7146: actions.EmitAction;
    evh_7716964648426498_close_7145: actions.EventHandlerImpl;
    act_7716964648426498_showModal_7144: actions.ShowModalAction;
    evh_7716964648426498_clickPreventStop_7143: actions.EventHandlerImpl;
    evh_7716964648426498_clickPreventStop: actions.EventHandlerGroup;
    act_2940653511262489_emit_7148: actions.EmitAction;
    evh_2940653511262489_clickPreventStop_7147: actions.EventHandlerImpl;
    evh_2940653511262489_clickPreventStop: actions.EventHandlerGroup;
    act_689536327456849_emit_7150: actions.EmitAction;
    evh_689536327456849_clickPreventStop_7149: actions.EventHandlerImpl;
    evh_689536327456849_clickPreventStop: actions.EventHandlerGroup;
    act_8254501898831426_showModal_7152: actions.ShowModalAction;
    evh_8254501898831426_clickPreventStop_7151: actions.EventHandlerImpl;
    evh_8254501898831426_clickPreventStop: actions.EventHandlerGroup;
    act_951936257455896_emit_7156: actions.EmitAction;
    evh_951936257455896_close_7155: actions.EventHandlerImpl;
    act_951936257455896_showModal_7154: actions.ShowModalAction;
    evh_951936257455896_click_7153: actions.EventHandlerImpl;
    evh_951936257455896_click: actions.EventHandlerGroup;
    act_7010716094810887_emit_7160: actions.EmitAction;
    evh_7010716094810887_success_7159: actions.EventHandlerImpl;
    act_7010716094810887_request_7158: actions.RequestAction;
    evh_7010716094810887_click_7157: actions.EventHandlerImpl;
    evh_7010716094810887_click: actions.EventHandlerGroup;
    act_4971252216919813_emit_7164: actions.EmitAction;
    evh_4971252216919813_close_7163: actions.EventHandlerImpl;
    act_4971252216919813_showModal_7162: actions.ShowModalAction;
    evh_4971252216919813_click_7161: actions.EventHandlerImpl;
    evh_4971252216919813_click: actions.EventHandlerGroup;
    act_3581444176199717_emit_7168: actions.EmitAction;
    evh_3581444176199717_success_7167: actions.EventHandlerImpl;
    act_3581444176199717_request_7166: actions.RequestAction;
    evh_3581444176199717_click_7165: actions.EventHandlerImpl;
    evh_3581444176199717_click: actions.EventHandlerGroup;
    act_6391442819935878_emit_7172: actions.EmitAction;
    evh_6391442819935878_success_7171: actions.EventHandlerImpl;
    act_6391442819935878_request_7170: actions.RequestAction;
    evh_6391442819935878_click_7169: actions.EventHandlerImpl;
    evh_6391442819935878_click: actions.EventHandlerGroup;
    act_2988515090283815_emit_7176: actions.EmitAction;
    evh_2988515090283815_success_7175: actions.EventHandlerImpl;
    act_2988515090283815_request_7174: actions.RequestAction;
    evh_2988515090283815_click_7173: actions.EventHandlerImpl;
    evh_2988515090283815_click: actions.EventHandlerGroup;
    act_3478991899028773_emit_7180: actions.EmitAction;
    evh_3478991899028773_success_7179: actions.EventHandlerImpl;
    act_3478991899028773_request_7178: actions.RequestAction;
    evh_3478991899028773_click_7177: actions.EventHandlerImpl;
    evh_3478991899028773_click: actions.EventHandlerGroup;
    act_8376575288437415_emit_7182: actions.EmitAction;
    evh_8376575288437415_success_7181: actions.EventHandlerImpl;
    evh_8376575288437415_success: actions.EventHandlerGroup;
    act_3958027742391354_emit_7184: actions.EmitAction;
    evh_3958027742391354_success_7183: actions.EventHandlerImpl;
    evh_3958027742391354_success: actions.EventHandlerGroup;
    act_8122162285230843_showModal_7186: actions.ShowModalAction;
    evh_8122162285230843_clickPreventStop_7185: actions.EventHandlerImpl;
    evh_8122162285230843_clickPreventStop: actions.EventHandlerGroup;
  }

  getActions() {
    const act_1048678296148443_emit_7134 = new actions.EmitAction(
      {
        actionArgs: this.act_1048678296148443_emit_7134_getActionArgs,
        events: [],
      }
    );
    const evh_1048678296148443_reload_7133 = new actions.EventHandlerImpl(
      {
        action: act_1048678296148443_emit_7134,
        event: "reload",
        displayName: "emit",
      }
    );
    const evh_1048678296148443_reload = new actions.EventHandlerGroup(
      {
        handlers: [evh_1048678296148443_reload_7133],
      }
    );
    const act_6639903447389385_emit_7136 = new actions.EmitAction(
      {
        actionArgs: this.act_6639903447389385_emit_7136_getActionArgs,
        events: [],
      }
    );
    const evh_6639903447389385_success_7135 = new actions.EventHandlerImpl(
      {
        action: act_6639903447389385_emit_7136,
        event: "success",
        displayName: "emit",
      }
    );
    const evh_6639903447389385_success = new actions.EventHandlerGroup(
      {
        handlers: [evh_6639903447389385_success_7135],
      }
    );
    const act_3803044933457651_emit_7138 = new actions.EmitAction(
      {
        actionArgs: this.act_3803044933457651_emit_7138_getActionArgs,
        events: [],
      }
    );
    const evh_3803044933457651_success_7137 = new actions.EventHandlerImpl(
      {
        action: act_3803044933457651_emit_7138,
        event: "success",
        displayName: "emit",
      }
    );
    const evh_3803044933457651_success = new actions.EventHandlerGroup(
      {
        handlers: [evh_3803044933457651_success_7137],
      }
    );
    const act_4764767232201234_emit_7140 = new actions.EmitAction(
      {
        actionArgs: this.act_4764767232201234_emit_7140_getActionArgs,
        events: [],
      }
    );
    const evh_4764767232201234_success_7139 = new actions.EventHandlerImpl(
      {
        action: act_4764767232201234_emit_7140,
        event: "success",
        displayName: "emit",
      }
    );
    const evh_4764767232201234_success = new actions.EventHandlerGroup(
      {
        handlers: [evh_4764767232201234_success_7139],
      }
    );
    const act_7992484462910578_emit_7142 = new actions.EmitAction(
      {
        actionArgs: this.act_7992484462910578_emit_7142_getActionArgs,
        events: [],
      }
    );
    const evh_7992484462910578_success_7141 = new actions.EventHandlerImpl(
      {
        action: act_7992484462910578_emit_7142,
        event: "success",
        displayName: "emit",
      }
    );
    const evh_7992484462910578_success = new actions.EventHandlerGroup(
      {
        handlers: [evh_7992484462910578_success_7141],
      }
    );
    const act_7716964648426498_emit_7146 = new actions.EmitAction(
      {
        actionArgs: this.act_7716964648426498_emit_7146_getActionArgs,
        events: [],
      }
    );
    const evh_7716964648426498_close_7145 = new actions.EventHandlerImpl(
      {
        action: act_7716964648426498_emit_7146,
        event: "close",
        when: this.evh_7716964648426498_close_7145_getWhen,
        displayName: "emit",
      }
    );
    const act_7716964648426498_showModal_7144 = new actions.ShowModalAction(
      {
        actionArgs: this.act_7716964648426498_showModal_7144_getActionArgs,
        events: [evh_7716964648426498_close_7145],
      }
    );
    const evh_7716964648426498_clickPreventStop_7143 = new actions.EventHandlerImpl(
      {
        action: act_7716964648426498_showModal_7144,
        event: "click.prevent.stop",
        displayName: "showModal",
      }
    );
    const evh_7716964648426498_clickPreventStop = new actions.EventHandlerGroup(
      {
        handlers: [evh_7716964648426498_clickPreventStop_7143],
      }
    );
    const act_2940653511262489_emit_7148 = new actions.EmitAction(
      {
        actionArgs: this.act_2940653511262489_emit_7148_getActionArgs,
        displayName: "reload",
        events: [],
      }
    );
    const evh_2940653511262489_clickPreventStop_7147 = new actions.EventHandlerImpl(
      {
        action: act_2940653511262489_emit_7148,
        event: "click.prevent.stop",
        displayName: "reload",
      }
    );
    const evh_2940653511262489_clickPreventStop = new actions.EventHandlerGroup(
      {
        handlers: [evh_2940653511262489_clickPreventStop_7147],
      }
    );
    const act_689536327456849_emit_7150 = new actions.EmitAction(
      {
        actionArgs: this.act_689536327456849_emit_7150_getActionArgs,
        displayName: "reload",
        events: [],
      }
    );
    const evh_689536327456849_clickPreventStop_7149 = new actions.EventHandlerImpl(
      {
        action: act_689536327456849_emit_7150,
        event: "click.prevent.stop",
        displayName: "reload",
      }
    );
    const evh_689536327456849_clickPreventStop = new actions.EventHandlerGroup(
      {
        handlers: [evh_689536327456849_clickPreventStop_7149],
      }
    );
    const act_8254501898831426_showModal_7152 = new actions.ShowModalAction(
      {
        actionArgs: this.act_8254501898831426_showModal_7152_getActionArgs,
        events: [],
      }
    );
    const evh_8254501898831426_clickPreventStop_7151 = new actions.EventHandlerImpl(
      {
        action: act_8254501898831426_showModal_7152,
        event: "click.prevent.stop",
        displayName: "showModal",
      }
    );
    const evh_8254501898831426_clickPreventStop = new actions.EventHandlerGroup(
      {
        handlers: [evh_8254501898831426_clickPreventStop_7151],
      }
    );
    const act_951936257455896_emit_7156 = new actions.EmitAction(
      {
        actionArgs: this.act_951936257455896_emit_7156_getActionArgs,
        events: [],
      }
    );
    const evh_951936257455896_close_7155 = new actions.EventHandlerImpl(
      {
        action: act_951936257455896_emit_7156,
        event: "close",
        when: this.evh_951936257455896_close_7155_getWhen,
        displayName: "emit",
      }
    );
    const act_951936257455896_showModal_7154 = new actions.ShowModalAction(
      {
        actionArgs: this.act_951936257455896_showModal_7154_getActionArgs,
        displayName: "registerInvoice",
        events: [evh_951936257455896_close_7155],
      }
    );
    const evh_951936257455896_click_7153 = new actions.EventHandlerImpl(
      {
        action: act_951936257455896_showModal_7154,
        event: "click",
        displayName: "registerInvoice",
      }
    );
    const evh_951936257455896_click = new actions.EventHandlerGroup(
      {
        handlers: [evh_951936257455896_click_7153],
      }
    );
    const act_7010716094810887_emit_7160 = new actions.EmitAction(
      {
        actionArgs: this.act_7010716094810887_emit_7160_getActionArgs,
        events: [],
      }
    );
    const evh_7010716094810887_success_7159 = new actions.EventHandlerImpl(
      {
        action: act_7010716094810887_emit_7160,
        event: "success",
        displayName: "emit",
      }
    );
    const act_7010716094810887_request_7158 = new actions.RequestAction(
      {
        actionArgs: this.act_7010716094810887_request_7158_getActionArgs,
        displayName: "createInvoicecopy",
        events: [evh_7010716094810887_success_7159],
      }
    );
    const evh_7010716094810887_click_7157 = new actions.EventHandlerImpl(
      {
        action: act_7010716094810887_request_7158,
        event: "click",
        displayName: "createInvoicecopy",
      }
    );
    const evh_7010716094810887_click = new actions.EventHandlerGroup(
      {
        handlers: [evh_7010716094810887_click_7157],
      }
    );
    const act_4971252216919813_emit_7164 = new actions.EmitAction(
      {
        actionArgs: this.act_4971252216919813_emit_7164_getActionArgs,
        events: [],
      }
    );
    const evh_4971252216919813_close_7163 = new actions.EventHandlerImpl(
      {
        action: act_4971252216919813_emit_7164,
        event: "close",
        when: this.evh_4971252216919813_close_7163_getWhen,
        displayName: "emit",
      }
    );
    const act_4971252216919813_showModal_7162 = new actions.ShowModalAction(
      {
        actionArgs: this.act_4971252216919813_showModal_7162_getActionArgs,
        displayName: "createPassThroughInvoice",
        events: [evh_4971252216919813_close_7163],
      }
    );
    const evh_4971252216919813_click_7161 = new actions.EventHandlerImpl(
      {
        action: act_4971252216919813_showModal_7162,
        event: "click",
        displayName: "createPassThroughInvoice",
      }
    );
    const evh_4971252216919813_click = new actions.EventHandlerGroup(
      {
        handlers: [evh_4971252216919813_click_7161],
      }
    );
    const act_3581444176199717_emit_7168 = new actions.EmitAction(
      {
        actionArgs: this.act_3581444176199717_emit_7168_getActionArgs,
        events: [],
      }
    );
    const evh_3581444176199717_success_7167 = new actions.EventHandlerImpl(
      {
        action: act_3581444176199717_emit_7168,
        event: "success",
        displayName: "emit",
      }
    );
    const act_3581444176199717_request_7166 = new actions.RequestAction(
      {
        actionArgs: this.act_3581444176199717_request_7166_getActionArgs,
        displayName: "createAdvanceInvoice",
        events: [evh_3581444176199717_success_7167],
      }
    );
    const evh_3581444176199717_click_7165 = new actions.EventHandlerImpl(
      {
        action: act_3581444176199717_request_7166,
        event: "click",
        displayName: "createAdvanceInvoice",
      }
    );
    const evh_3581444176199717_click = new actions.EventHandlerGroup(
      {
        handlers: [evh_3581444176199717_click_7165],
      }
    );
    const act_6391442819935878_emit_7172 = new actions.EmitAction(
      {
        actionArgs: this.act_6391442819935878_emit_7172_getActionArgs,
        events: [],
      }
    );
    const evh_6391442819935878_success_7171 = new actions.EventHandlerImpl(
      {
        action: act_6391442819935878_emit_7172,
        event: "success",
        displayName: "emit",
      }
    );
    const act_6391442819935878_request_7170 = new actions.RequestAction(
      {
        actionArgs: this.act_6391442819935878_request_7170_getActionArgs,
        displayName: "createFinalInvoice",
        events: [evh_6391442819935878_success_7171],
      }
    );
    const evh_6391442819935878_click_7169 = new actions.EventHandlerImpl(
      {
        action: act_6391442819935878_request_7170,
        event: "click",
        displayName: "createFinalInvoice",
      }
    );
    const evh_6391442819935878_click = new actions.EventHandlerGroup(
      {
        handlers: [evh_6391442819935878_click_7169],
      }
    );
    const act_2988515090283815_emit_7176 = new actions.EmitAction(
      {
        actionArgs: this.act_2988515090283815_emit_7176_getActionArgs,
        events: [],
      }
    );
    const evh_2988515090283815_success_7175 = new actions.EventHandlerImpl(
      {
        action: act_2988515090283815_emit_7176,
        event: "success",
        displayName: "emit",
      }
    );
    const act_2988515090283815_request_7174 = new actions.RequestAction(
      {
        actionArgs: this.act_2988515090283815_request_7174_getActionArgs,
        displayName: "createStornoInvoice",
        events: [evh_2988515090283815_success_7175],
      }
    );
    const evh_2988515090283815_click_7173 = new actions.EventHandlerImpl(
      {
        action: act_2988515090283815_request_7174,
        event: "click",
        displayName: "createStornoInvoice",
      }
    );
    const evh_2988515090283815_click = new actions.EventHandlerGroup(
      {
        handlers: [evh_2988515090283815_click_7173],
      }
    );
    const act_3478991899028773_emit_7180 = new actions.EmitAction(
      {
        actionArgs: this.act_3478991899028773_emit_7180_getActionArgs,
        events: [],
      }
    );
    const evh_3478991899028773_success_7179 = new actions.EventHandlerImpl(
      {
        action: act_3478991899028773_emit_7180,
        event: "success",
        displayName: "emit",
      }
    );
    const act_3478991899028773_request_7178 = new actions.RequestAction(
      {
        actionArgs: this.act_3478991899028773_request_7178_getActionArgs,
        displayName: "createCorrectorIvoice",
        events: [evh_3478991899028773_success_7179],
      }
    );
    const evh_3478991899028773_click_7177 = new actions.EventHandlerImpl(
      {
        action: act_3478991899028773_request_7178,
        event: "click",
        displayName: "createCorrectorIvoice",
      }
    );
    const evh_3478991899028773_click = new actions.EventHandlerGroup(
      {
        handlers: [evh_3478991899028773_click_7177],
      }
    );
    const act_8376575288437415_emit_7182 = new actions.EmitAction(
      {
        actionArgs: this.act_8376575288437415_emit_7182_getActionArgs,
        events: [],
      }
    );
    const evh_8376575288437415_success_7181 = new actions.EventHandlerImpl(
      {
        action: act_8376575288437415_emit_7182,
        event: "success",
        displayName: "emit",
      }
    );
    const evh_8376575288437415_success = new actions.EventHandlerGroup(
      {
        handlers: [evh_8376575288437415_success_7181],
      }
    );
    const act_3958027742391354_emit_7184 = new actions.EmitAction(
      {
        actionArgs: this.act_3958027742391354_emit_7184_getActionArgs,
        events: [],
      }
    );
    const evh_3958027742391354_success_7183 = new actions.EventHandlerImpl(
      {
        action: act_3958027742391354_emit_7184,
        event: "success",
        displayName: "emit",
      }
    );
    const evh_3958027742391354_success = new actions.EventHandlerGroup(
      {
        handlers: [evh_3958027742391354_success_7183],
      }
    );
    const act_8122162285230843_showModal_7186 = new actions.ShowModalAction(
      {
        actionArgs: this.act_8122162285230843_showModal_7186_getActionArgs,
        events: [],
      }
    );
    const evh_8122162285230843_clickPreventStop_7185 = new actions.EventHandlerImpl(
      {
        action: act_8122162285230843_showModal_7186,
        event: "click.prevent.stop",
        displayName: "showModal",
      }
    );
    const evh_8122162285230843_clickPreventStop = new actions.EventHandlerGroup(
      {
        handlers: [evh_8122162285230843_clickPreventStop_7185],
      }
    );
    return {
      act_1048678296148443_emit_7134,
      evh_1048678296148443_reload_7133,
      evh_1048678296148443_reload,
      act_6639903447389385_emit_7136,
      evh_6639903447389385_success_7135,
      evh_6639903447389385_success,
      act_3803044933457651_emit_7138,
      evh_3803044933457651_success_7137,
      evh_3803044933457651_success,
      act_4764767232201234_emit_7140,
      evh_4764767232201234_success_7139,
      evh_4764767232201234_success,
      act_7992484462910578_emit_7142,
      evh_7992484462910578_success_7141,
      evh_7992484462910578_success,
      act_7716964648426498_emit_7146,
      evh_7716964648426498_close_7145,
      act_7716964648426498_showModal_7144,
      evh_7716964648426498_clickPreventStop_7143,
      evh_7716964648426498_clickPreventStop,
      act_2940653511262489_emit_7148,
      evh_2940653511262489_clickPreventStop_7147,
      evh_2940653511262489_clickPreventStop,
      act_689536327456849_emit_7150,
      evh_689536327456849_clickPreventStop_7149,
      evh_689536327456849_clickPreventStop,
      act_8254501898831426_showModal_7152,
      evh_8254501898831426_clickPreventStop_7151,
      evh_8254501898831426_clickPreventStop,
      act_951936257455896_emit_7156,
      evh_951936257455896_close_7155,
      act_951936257455896_showModal_7154,
      evh_951936257455896_click_7153,
      evh_951936257455896_click,
      act_7010716094810887_emit_7160,
      evh_7010716094810887_success_7159,
      act_7010716094810887_request_7158,
      evh_7010716094810887_click_7157,
      evh_7010716094810887_click,
      act_4971252216919813_emit_7164,
      evh_4971252216919813_close_7163,
      act_4971252216919813_showModal_7162,
      evh_4971252216919813_click_7161,
      evh_4971252216919813_click,
      act_3581444176199717_emit_7168,
      evh_3581444176199717_success_7167,
      act_3581444176199717_request_7166,
      evh_3581444176199717_click_7165,
      evh_3581444176199717_click,
      act_6391442819935878_emit_7172,
      evh_6391442819935878_success_7171,
      act_6391442819935878_request_7170,
      evh_6391442819935878_click_7169,
      evh_6391442819935878_click,
      act_2988515090283815_emit_7176,
      evh_2988515090283815_success_7175,
      act_2988515090283815_request_7174,
      evh_2988515090283815_click_7173,
      evh_2988515090283815_click,
      act_3478991899028773_emit_7180,
      evh_3478991899028773_success_7179,
      act_3478991899028773_request_7178,
      evh_3478991899028773_click_7177,
      evh_3478991899028773_click,
      act_8376575288437415_emit_7182,
      evh_8376575288437415_success_7181,
      evh_8376575288437415_success,
      act_3958027742391354_emit_7184,
      evh_3958027742391354_success_7183,
      evh_3958027742391354_success,
      act_8122162285230843_showModal_7186,
      evh_8122162285230843_clickPreventStop_7185,
      evh_8122162285230843_clickPreventStop,
      reload: act_689536327456849_emit_7150,
      registerInvoice: act_951936257455896_showModal_7154,
      createInvoicecopy: act_7010716094810887_request_7158,
      createPassThroughInvoice: act_4971252216919813_showModal_7162,
      createAdvanceInvoice: act_3581444176199717_request_7166,
      createFinalInvoice: act_6391442819935878_request_7170,
      createStornoInvoice: act_2988515090283815_request_7174,
      createCorrectorIvoice: act_3478991899028773_request_7178,
    }
  }
}

Vue.component("UcInvoiceHeader", UcInvoiceHeader);

</script>